/**
 * TriStateCheckbox — prymityw `Checkbox` sterowany jednym stanem trójwartościowym
 * („zaznaczony" / „częściowy" / „pusty") zamiast dwóch flag.
 *
 * Stan „częściowy" obsługuje sam prymityw (`indeterminate` — właściwość DOM ustawiana w jego
 * efekcie), więc wrapper tylko mapuje `state` na `checked` + `indeterminate`. Zero forka
 * prymitywu, zero surowego `<input>` (bramka lintu z CLAUDE.md §4.12).
 */

import { Checkbox, type CheckboxProps } from '@/components/Checkbox';

export type TriState = 'checked' | 'indeterminate' | 'unchecked';

export interface TriStateCheckboxProps extends Omit<
  CheckboxProps,
  'checked' | 'defaultChecked' | 'indeterminate'
> {
  state: TriState;
}

export function TriStateCheckbox({ state, ...rest }: TriStateCheckboxProps) {
  return (
    <Checkbox checked={state === 'checked'} indeterminate={state === 'indeterminate'} {...rest} />
  );
}
